import self from "../img/self.png";

/// Sia App Images
import siaBackground from "../img/siabackground.png";
import siaIcon from "../img/siaicon.png";

/// Wazen App Images
import wazenBackground from "../img/wazenbackground.png";
import wazenIcon from "../img/wazenicon.png";

/// fi Alforn App Images
import fiAlFornBackground from "../img/fialfornbackground.png";
import fiAlFornIcon from "../img/fialfornicon.png";

/// Tour key go Images
import tourKeyGoBackground from "../img/tourkeygobackground.png";
import tourKeyGoIcon from "../img/tourkeygoicon.png";

/// Maqdia App Images
import maqdiaBackground from "../img/maqdiabackground.png";
import maqdiaIcon from "../img/maqdiaicon.png";

/// Sanae3y Pro App Images
import sanae3yProBackground from "../img/sanae3yprobackground.png";
import sanae3yProIcon from "../img/sanae3yproicon.png";

/// Delora App Images
import deloraBackground from "../img/delorabackground.png";
import deloraIcon from "../img/deloraicon.png";

/// Champions Fantasy App Images
import championFantasyBackground from "../img/championfantasybackground.png";
import championFantasyIcon from "../img/championfantasyIcon.png";

/// Izemak App Images
import izemakBackground from "../img/izemakbackground.png";
import izemakIcon from "../img/izemakIcon.png";

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */

/* 
This variable will change the layout of the website from multipage to single, scrollable page
*/
export let singlePage = false;

/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
  firstName: "Mohamed",
  lastName: "Osama",
  initials: "Flutter", // the example uses first and last, but feel free to use three or more if you like.
  position: "Flutter Developer",
  selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
  gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
  baseColor: colors[0],

  miniBio: [
    // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
    {
      emoji: "☕",
      text: "Fueled by coffee",
    },
    {
      emoji: "🌎",
      text: "Based in Egypt",
    },
    {
      emoji: "💼",
      text: "Flutter Developer | Mobile App Engineer",
    },
  ],

  socials: [
    {
      link: "mailto:mossama370@gmail.com",
      icon: "fa fa-google",
      label: "email",
    },
    {
      link: "https://www.linkedin.com/in/mohamed-osama2003/",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },

    // {
    //   link: "https://www.facebook.com/mossama2003",
    //   icon: "fa fa-facebook",
    //   label: "facebook",
    // },
    // {
    //   link: "https://www.instagram.com/mo7amedosama2003/",
    //   icon: "fa fa-instagram",
    //   label: "instagram",
    // },
    {
      link: "https://github.com/mossama2003",
      icon: "fa fa-github",
      label: "github",
    },
    {
      link: "https://wa.me/201129304599",
      icon: "fa fa-whatsapp",
      label: "whatsapp",
    },
    // {
    //   link: "https://x.com/mossama350",
    //   icon: "fa fa-twitter",
    //   label: "twitter",
    // },
  ],

  bio: "Hello! I'm Mohamed, a Flutter Developer with 3+ years of professional experience building cross-platform mobile applications. I've developed and delivered production-ready apps, with experience taking projects from idea and requirements analysis through development, testing, and deployment on Google Play and the App Store. I'm skilled in Flutter, Dart, Clean Architecture, Cubit/Bloc, REST APIs, Firebase, and CI/CD, with a focus on scalable architecture, performance, and clean, maintainable code. I'm passionate about learning, solving real-world problems, and continuously improving my skills to build smooth and reliable user experiences. I'm always open to new opportunities, challenges, and collaborations.",

  skills: {
    proficientWith: [
      "dart",
      "flutter",
      "material design",
      "bloc",
      "cubit",
      "riverpod",
      "clean architecture",
      "mvvm",
      "repository pattern",
      "feature-based architecture",
      "rest api",
      "dio",
      "json serialization",
      "firebase",
      "firestore",
      "shorebird",
      "realtime database",
      "sqflite",
      "shared preferences",
      "Hive",
      "Shorebird",
      "git",
      "github",
      "android studio",
    ],
    exposedTo: [
      "jenkins",
      "github actions",
      "fvm",
      "unit testing",
      "widget testing",
      "oop",
      "responsive ui",
      "localization",
      "push notifications",
      "performance optimization",
    ],
  },

  hobbies: [
    { label: "football", emoji: "⚽" },
    { label: "movies", emoji: "🎬" },
    { label: "music", emoji: "🎧" },
    { label: "coding", emoji: "💻" },
  ],

  portfolio: [
    /// Sia Project
    {
      title: "SIA - Smart Investment Analyzer",
      description:
        "AI-powered investment and virtual trading platform that provides real-time market insights, stock analysis, portfolio tracking, and intelligent trading assistance.",
      image: siaBackground,
      icon: siaIcon,
      tech: [
        "Flutter",
        "Dart",
        "Python",
        "AI / Machine Learning",
        "Yahoo Finance Data",
        "Dio",
        "FAST API",
        "Cubit",
        "Repository Pattern",
      ],
      features: [
        "AI Market Analysis",
        "Real-Time Market Pulse",
        "EGX 30 Index Tracking",
        "AI Market Score",
        "Real-Time Stock Data",
        "Trending Stocks",
        "Live Sparkline Charts",
        "Stock Search & Filtering",
        "Stock Analysis",
        "Tracked Stocks",
        "Buy & Sell Simulation",
        "Virtual Trading",
        "Order Management",
        "Real-Time Order Summary",
        "Estimated P&L",
        "Order History",
        "Portfolio Management",
        "Asset Allocation",
        "Performance Tracking",
        "Top Performers & Underperformers",
        "Real-Time AI Alerts",
        "Market Alerts",
        "Order Alerts",
        "Risk Alerts",
        "SIA AI Assistant",
        "AI-Powered Investment Support",
        "Individual Stock Analysis",
        "Financial Indicators",
        "Animated Stock Charts",
        "Trading Statistics",
        "Dark & Light Mode",
        "Arabic & English Support",
        "Secure Account Management",
        "Custom Authentication",
        "Social Login",
        "AI Model Development",
        "AI Model Training",
        "Python-Based Machine Learning",
        "Yahoo Finance Dataset Integration",
      ],
      status: "In Development",
      googlePlay: null,
      appStore: null,
    },

    /// Wazen Project
    {
      title: "Wazen App",

      description:
        "AI-powered nutrition tracking application that helps users analyze meals, track calories, monitor daily health progress, and improve their lifestyle through smart food insights.",

      image: wazenBackground,

      icon: wazenIcon,

      tech: [
        "Flutter",
        "Dart",
        "Dio",
        "REST API",
        "AI Integration",
        "Repository Pattern",
        "State Management",
      ],

      features: [
        "AI Meal Analysis",
        "Image & Voice Food Recognition",
        "Barcode Food Scanner",
        "Calorie & Macronutrient Tracking",
        "Water Intake Monitoring",
        "Workout Calories Estimation",
        "Daily Progress Tracking",
        "Social Sharing Features",
        "Google Play Published App",
        "App Store Published App",
      ],

      googlePlay:
        "https://play.google.com/store/apps/details?id=com.wazen.health.wazen_app",

      appStore:
        "https://apps.apple.com/us/app/wazen-%D9%88%D8%A7%D8%B2%D9%86/id6760981534",
    },

    /// Maqdia Project
    {
      title: "Maqdia App",

      description:
        "AI-powered marketplace connecting customers with trusted service providers for on-demand home, office, maintenance, cleaning, moving, and other services.",

      image: maqdiaBackground,

      icon: maqdiaIcon,

      tech: [
        "Flutter",
        "Dart",
        "Dio",
        "REST API",
        "Cubit",
        "AI Integration",
        "Repository Pattern",
      ],

      features: [
        "Service Marketplace",
        "Service Provider Discovery",
        "On-Demand Services",
        "AI-Powered Features",
        "Text-Based Requests",
        "Image-Based Requests",
        "Voice-Based Requests",
        "Service Provider Profiles",
        "REST API Integration",
        "Pagination",
        "Advanced Error Handling",
        "Optimized Data Flow",
        "Feature-Based Architecture",
        "Repository Pattern",
        "Google Play Published App",
        "App Store Published App",
      ],

      googlePlay:
        "https://play.google.com/store/apps/details?id=com.sarh.maqdia&hl=en",

      appStore: "https://apps.apple.com/eg/app/maqdia/id6753150399",
    },

    ///Sanae3y Pro Project
    {
      title: "Sanae3y Pro App",

      description:
        "Home services marketplace that allows customers to create service requests, receive offers from available technicians, compare prices, negotiate, and choose the most suitable offer.",

      image: sanae3yProBackground,

      icon: sanae3yProIcon,

      tech: [
        "Flutter",
        "Dart",
        "Dio",
        "REST API",
        "Cubit",
        "Repository Pattern",
      ],

      features: [
        "Service Request Creation",
        "Technician Offers",
        "Price Comparison",
        "Offer Negotiation",
        "Technician Selection",
        "Plumbing Services",
        "Electrical Services",
        "Carpentry Services",
        "Painting Services",
        "AC Maintenance",
        "Glass Services",
        "Insulation Services",
        "REST API Integration",
        "Efficient Data Management",
        "Google Play Published App",
        "App Store Published App",
      ],

      googlePlay:
        "https://play.google.com/store/apps/details?id=com.blink.sanae3ypro",

      appStore:
        "https://apps.apple.com/eg/app/sanae3y-pro-%D8%B5%D9%86%D8%A7%D9%8A%D8%B9%D9%8A-%D8%A8%D8%B1%D9%88/id6774985991",
    },

    /// Tour Key Go Project
    {
      title: "Tour Key Go App",

      description:
        "Transportation and ride-booking platform that provides customers and drivers with a seamless experience for destination selection, trip management, and ride booking.",

      image: tourKeyGoBackground,

      icon: tourKeyGoIcon,

      tech: [
        "Flutter",
        "Dart",
        "Dio",
        "REST API",
        "Cubit",
        "Geolocation",
        "Repository Pattern",
      ],

      features: [
        "Ride Booking",
        "Trip Management",
        "Destination Selection",
        "Geolocation Integration",
        "Mapping & Routing",
        "Customer Application",
        "Driver Application",
        "REST API Integration",
        "Scalable State Management",
        "Repository Pattern",
        "Google Play Published App",
        "App Store Published App",
      ],

      googlePlay:
        "https://play.google.com/store/apps/details?id=com.blink.tourkeygo",

      appStore: "https://apps.apple.com/eg/app/tour-key-go/id6768152190",
    },

    /// Fi AlForn Project
    {
      title: "Fi AlForn App",

      description:
        "UAE-based food ordering application that provides users with a seamless experience for browsing menus, managing their cart, and completing checkout workflows.",

      image: fiAlFornBackground,

      icon: fiAlFornIcon,

      tech: [
        "Flutter",
        "Dart",
        "Dio",
        "REST API",
        "Cubit",
        "Firebase",
        "Repository Pattern",
      ],

      features: [
        "Menu Browsing",
        "Cart Management",
        "Checkout Workflow",
        "Authentication",
        "REST API Integration",
        "Error Handling",
        "Firebase Integration",
        "Efficient Data Management",
        "Google Play Published App",
        "App Store Published App",
      ],

      googlePlay:
        "https://play.google.com/store/apps/details?id=com.fialforn.fialforn",

      appStore: "https://apps.apple.com/at/app/fi-alforn/id6778437948",
    },

    /// Deloara Project
    {
      title: "Delora App",

      description:
        "E-commerce beauty shopping application offering a seamless experience for browsing and purchasing beauty, perfumes, makeup, skincare, haircare, nail care, and wellness products.",

      image: deloraBackground,

      icon: deloraIcon,

      tech: [
        "Flutter",
        "Dart",
        "Dio",
        "REST API",
        "Cubit",
        "Repository Pattern",
      ],

      features: [
        "Product Browsing",
        "Category Browsing",
        "Beauty Products",
        "Perfumes & Makeup",
        "Skincare & Haircare",
        "Nail Care Products",
        "Wellness Products",
        "Shopping Cart",
        "Checkout",
        "Order Management",
        "Order Tracking",
        "Address Management",
        "Account Management",
        "Discount Coupons",
        "Special Offers",
        "REST API Integration",
        "Efficient Data Management",
      ],

      googlePlay:
        "https://play.google.com/store/apps/details?id=com.blink.delora",

      appStore: "https://apps.apple.com/us/app/delora/id6774976410",
    },

    /// Champions Fantasy Project
    {
      title: "Champion Fantasy App",

      description:
        "Fantasy football application combining the Saudi Pro League, La Liga, and Premier League in one competitive experience, allowing users to build their dream team, manage transfers, and compete in multiple fantasy leagues.",

      image: championFantasyBackground,

      icon: championFantasyIcon,

      tech: [
        "Flutter",
        "Dart",
        "Dio",
        "REST API",
        "Cubit",
        "Repository Pattern",
      ],

      features: [
        "Fantasy Football",
        "15-Player Squad Building",
        "100M Budget System",
        "Player Transfers",
        "Captain Selection",
        "Double Captain Points",
        "Wildcard",
        "Free Hit",
        "Bench Boost",
        "Triple Captain",
        "Live Fantasy Points",
        "Live Match Events",
        "Live Lineups",
        "Player Performance Tracking",
        "Global Leagues",
        "Private Leagues",
        "Local Leagues",
        "Invite Codes",
        "Premier League",
        "La Liga",
        "Saudi Pro League",
        "Bundesliga",
        "Serie A",
        "Football News",
        "Champion Pro",
        "REST API Integration",
        "Real-Time Data",
      ],

      googlePlay:
        "https://play.google.com/store/apps/details?id=com.blink.champion",

      appStore: "https://apps.apple.com/app/id6799524166",
    },

    /// IZEMAK Project
    {
      title: "Izemak App",

      description:
        "Digital invitation creation app that makes it easy to design elegant and personalized invitations for weddings, birthdays, engagements, graduations, and other special occasions.",

      image: izemakBackground,

      icon: izemakIcon,

      tech: [
        "Flutter",
        "Dart",
        "Dio",
        "REST API",
        "Cubit",
        "Repository Pattern",
      ],

      features: [
        "Digital Invitations",
        "Invitation Templates",
        "Wedding Invitations",
        "Birthday Invitations",
        "Engagement Invitations",
        "Graduation Invitations",
        "Customizable Designs",
        "Text Customization",
        "Event Details Customization",
        "Names & Date Customization",
        "Location Details",
        "Personal Messages",
        "Invitation Preview",
        "Fast Invitation Creation",
        "Social Media Sharing",
        "WhatsApp Sharing",
        "Facebook Sharing",
        "Email Sharing",
        "User-Friendly Interface",
        "Modern Invitation Designs",
        "Google Play Published App",
        "App Store Published App",
      ],

      googlePlay:
        "https://play.google.com/store/apps/details?id=com.infinity.izemak",

      appStore: "https://apps.apple.com/eg/app/izemak/id6760264474",
    },
  ],
};
